import { DEV } from "solid-js"
import { Color } from "three"
import { freeze } from "../../core/util/Object"

const white = new Color(0xffffff)

if (DEV) {
  freeze(white)
}

const greyHSL = { h: 0, s: 0, l: 0 }
const baseHSL = { h: 0, s: 0, l: 0 }

export default function applyLuminanceFromGreyscale(
  greyScale: Readonly<Color>,
  baseColor: Readonly<Color>,
  writeColor?: Color | null,
): Color {
  if (greyScale.equals(white)) {
    return baseColor.clone()
  }
  // Convert greyscale color to HSL to extract its luminance
  greyScale.getHSL(greyHSL)

  // Convert base color to HSL to modify its luminance
  baseColor.getHSL(baseHSL)

  // Apply the luminance of the greyscale color to the base color
  const finalColor = writeColor || new Color()
  finalColor.setHSL(baseHSL.h, baseHSL.s, greyHSL.l)

  return finalColor
}